module.exports = __webpack_public_path__ + "img/ico_sub_prod_brityrpa03.b03450ed.png";